export const ecommerceConstants = {
  errorTimer: 15000,
  colors: {
    yellow: '#ffc244',
    yellowDark: '#e19f17',
    green: '#2abb9b',
    greenDark: '#00a082',
    black: '#000000',
    grey: '#6e6e6e',
  },
  urls: {
    home: {
      KE: 'home',
      GH: 'home',
      ES: 'inicio',
      PL: 'glowna',
      PT: 'comeco',
      RO: 'inceput',
      MD: 'inceput',
      HR: 'pocetak',
      IT: 'inizio',
      MA: 'debut',
      CI: 'debut',
      GE: 'dacqeba',
      KZ: 'glavnaia',
      KG: 'glavnaia',
      UA: 'golovna',
      RS: 'pocni',
      SI: 'zacetek',
      BG: 'nachalo',
      BA: 'pocetak',
      ME: 'pocni',
      AD: 'inici',
      AM: 'glkhavor-ej',
    },
    login: {
      KE: 'login',
      GH: 'login',
      ES: 'iniciar-sesion',
      PL: 'logowanie',
      PT: 'iniciar-sessao',
      RO: 'autentificare',
      MD: 'autentificare',
      HR: 'prijavi-se',
      IT: 'accesso',
      MA: 'connexion',
      CI: 'connexion',
      GE: 'avtorizac-ia',
      KZ: 'vkhod',
      KG: 'vkhod',
      UA: 'vkhid',
      RS: 'prijava',
      SI: 'prijava',
      BG: 'vkhod',
      BA: 'prijava',
      ME: 'prijava',
      AD: 'iniciar-sessio',
      AM: 'mowtk',
    },
    'auto-login': {
      KE: 'auto-login',
      GH: 'auto-login',
      ES: 'auto-login',
      PL: 'automatyczne-logowanie',
      PT: 'login-automatico',
      RO: 'autentificare-automata',
      MD: 'autentificare-automata',
      HR: 'automatska-prijava',
      IT: 'accesso-automatico',
      MA: 'connexion-automatique',
      CI: 'connexion-automatique',
      GE: 'avtomaturi-shesvla',
      KZ: 'avtomatty-kiru',
      KG: 'avtomatty-kiru',
      UA: 'avtomatychnyi-vkhid',
      RS: 'automatska-prijava',
      SI: 'samodejna-prijava',
      BG: 'avtomatichno-vlizane',
      BA: 'automatska-prijava',
      ME: 'automatska-prijava',
      AD: 'connexio-automatica',
      AM: 'avtomat-mowtk',
    },
    'recover-password': {
      KE: 'recover-password',
      GH: 'recover-password',
      ES: 'recuperar-contrasena',
      PL: 'odzyskiwanie-hasla',
      PT: 'recuperar-palavra-passe',
      RO: 'recupereaza-parola',
      MD: 'recupereaza-parola',
      HR: 'zaboravljena-lozinka',
      IT: 'recupera-la-password',
      MA: 'recuperer-mot-de-passe',
      CI: 'recuperer-mot-de-passe',
      GE: 'parolisag-dgena',
      KZ: 'vosstanovit--parol',
      KG: 'vosstanovit--parol',
      UA: 'vidnoviti-parol',
      RS: 'obnova-lozinke',
      SI: 'obnovitev-gesla',
      BG: 'v-zstanoviavane-na-parolata',
      BA: 'oporavi-lozinku',
      ME: 'obnova-lozinke',
      AD: 'recuperar-contrasenya',
      AM: 'verakangnel-gaghtnabarh',
    },
    register: {
      KE: 'register',
      GH: 'register',
      ES: 'registro',
      PL: 'rejestracja',
      PT: 'registo',
      RO: 'inregistrare',
      MD: 'inregistrare',
      HR: 'snimi',
      IT: 'registrati',
      MA: 'enregistrement',
      CI: 'enregistrement',
      GE: 'registrac-ia',
      KZ: 'registratsiia',
      KG: 'registratsiia',
      UA: 'reiestratsiia',
      RS: 'registracija',
      SI: 'registracija',
      BG: 'registratsiia',
      BA: 'registracija',
      ME: 'registracija',
      AD: 'registre',
      AM: 'grants-vel',
    },
    activation: {
      KE: 'activation',
      GH: 'activation',
      ES: 'activacion',
      PL: 'aktywacja',
      PT: 'ativacao',
      RO: 'activare',
      MD: 'activare',
      HR: 'aktivacija',
      IT: 'attivazione',
      MA: 'activation',
      CI: 'activation',
      GE: 'ak-tivac-ia',
      KZ: 'aktivatsiia',
      KG: 'aktivatsiia',
      UA: 'aktivatsiia',
      RS: 'aktivacija',
      SI: 'aktivacija',
      BG: 'aktivirane',
      BA: 'aktivacija',
      ME: 'aktivacija',
      AD: 'activacio',
      AM: 'aktivats-owm',
    },
    products: {
      KE: 'products',
      GH: 'products',
      ES: 'productos',
      PL: 'produkty',
      PT: 'produtos',
      RO: 'produse',
      MD: 'produse',
      HR: 'proizvoda',
      IT: 'prodotti',
      MA: 'produits',
      CI: 'produits',
      GE: 'produk-tebi',
      KZ: 'tovary',
      KG: 'tovary',
      UA: 'tovari',
      RS: 'proizvodi',
      SI: 'izdelki',
      BG: 'produkti',
      BA: 'proizvodi',
      ME: 'proizvodi',
      AD: 'productes',
      AM: 'aprank-ner',
    },
    product: {
      KE: 'product',
      GH: 'product',
      ES: 'producto',
      PL: 'produkt',
      PT: 'produto',
      RO: 'produs',
      MD: 'produs',
      HR: 'proizvod',
      IT: 'prodotto',
      MA: 'produit',
      CI: 'produit',
      GE: 'produk-ti',
      KZ: 'tovar',
      KG: 'tovar',
      UA: 'tovar',
      RS: 'proizvod',
      SI: 'izdelek',
      BG: 'produkt',
      BA: 'proizvod',
      ME: 'proizvod',
      AD: 'producte',
      AM: 'aprank',
    },
    'favourite-products': {
      KE: 'favourite-products',
      GH: 'favourite-products',
      ES: 'productos-favoritos',
      PL: 'ulubione-produkty',
      PT: 'produtos-favoritos',
      RO: 'produsele-preferate',
      MD: 'produsele-preferate',
      HR: 'omiljeni-proizvodi',
      IT: 'prodotti-preferiti',
      MA: 'produits-favoris',
      CI: 'produits-favoris',
      GE: 'saqvareliproduk-tebi',
      KZ: 'izbrannoe',
      KG: 'izbrannoe',
      UA: 'vibrane',
      RS: 'omiljeni-proizvodi',
      SI: 'priljubljeni-izdelki',
      BG: 'liubimi-produkti',
      BA: 'omiljeni-proizvodi',
      ME: 'omiljeni-proizvodi',
      AD: 'productes-preferits',
      AM: 'nakhentreli-aprank-ner',
    },
    'featured-products': {
      KE: 'featured-products',
      GH: 'featured-products',
      ES: 'productos-destacados',
      PL: 'wyroznione-produkty',
      PT: 'produtos-em-destaque',
      RO: 'produse-recomandate',
      MD: 'produse-recomandate',
      HR: 'izdvojeni-proizvodi',
      IT: 'prodotti-in-evidenza',
      MA: 'produits-en-vedette',
      CI: 'produits-en-vedette',
      GE: 'gamorcheuli-produk-tebi',
      KZ: 'izbrannye-tovary',
      KG: 'izbrannye-tovary',
      UA: 'rekomendovani-tovary',
      RS: 'izdvojeni-proizvodi',
      SI: 'izpostavljeni-izdelki',
      BG: 'preporachani-produkti',
      BA: 'izdvojeni-proizvodi',
      ME: 'izdvojeni-proizvodi',
      AD: 'productes-destacats',
      AM: 'betam-meseretoch',
    },
    'search-results': {
      KE: 'search-results',
      GH: 'search-results',
      ES: 'resultados-de-busqueda',
      PL: 'wyniki-wyszukiwania',
      PT: 'resultados-pesquisa',
      RO: 'rezultatele-cautarii',
      MD: 'rezultatele-cautarii',
      HR: 'rezultati-pretrazivanja',
      IT: 'risultati-di-ricerca',
      MA: 'resultats-de-recherche',
      CI: 'resultats-de-recherche',
      GE: 'z-iebisshedegi',
      KZ: 'rezul-taty-poiska',
      KG: 'rezul-taty-poiska',
      UA: 'rezul-tati-poshuku',
      RS: 'rezultati-pretrage',
      SI: 'rezultati-iskanja',
      BG: 'rezultati-ot-t-rseneto',
      BA: 'rezultati-pretrage',
      ME: 'rezultati-pretrage',
      AD: 'resultats-de-cerca',
      AM: 'oronman-ardyownk-nere',
    },
    'product-catalog': {
      KE: 'product-catalog',
      GH: 'product-catalog',
      ES: 'catalogo-productos',
      PL: 'katalog-produktow',
      PT: 'catalogo-produtos',
      RO: 'catalog-de-produse',
      MD: 'catalog-de-produse',
      HR: 'katalog-proizvoda',
      IT: 'catalogo-prodotti',
      MA: 'catalogue-de-produit',
      CI: 'catalogue-de-produit',
      GE: 'produk-t-katalogi',
      KZ: 'katalog-produktsii',
      KG: 'katalog-produktsii',
      UA: 'katalog-tovariv',
      RS: 'proizvod-katalog',
      SI: 'katalog-izdelkov',
      BG: 'produktov-katalog',
      BA: 'proizvod-katalog',
      ME: 'proizvod-katalog',
      AD: 'cataleg-de-productes',
      AM: 'aprank--katalog',
    },
    category: {
      KE: 'category',
      GH: 'category',
      ES: 'categoria',
      PL: 'kategoria',
      PT: 'categoria',
      RO: 'categorie',
      MD: 'categorie',
      HR: 'kategorija',
      IT: 'categoria',
      MA: 'categorie',
      CI: 'categorie',
      GE: 'kategoria',
      KZ: 'kategoriia',
      KG: 'kategoriia',
      UA: 'kategoriia',
      RS: 'kategorija',
      SI: 'kategorija',
      BG: 'kategoriia',
      BA: 'kategorija',
      ME: 'kategorija',
      AD: 'categoria',
      AM: 'kategoria',
    },
    collection: {
      KE: 'collection',
      GH: 'collection',
      ES: 'coleccion',
      PL: 'kolekcja',
      PT: 'colecao',
      RO: 'colectie',
      MD: 'colectie',
      HR: 'kolekcija',
      IT: 'collezione',
      MA: 'collection',
      CI: 'collection',
      GE: 'kolek-c-ia',
      KZ: 'kollektsiia',
      KG: 'kollektsiia',
      UA: 'kolektsiia',
      RS: 'kolekcija',
      SI: 'zbirka',
      BG: 'kolektsiia',
      BA: 'kolekcija',
      ME: 'kolekcija',
      AD: 'colleccio',
      AM: 'havak-atsow',
    },
    pack: {
      KE: 'pack',
      GH: 'pack',
      ES: 'pack',
      PL: 'pakiet',
      PT: 'pacote',
      RO: 'ambalaj',
      MD: 'ambalaj',
      HR: 'paket',
      IT: 'pacchetto',
      MA: 'paquet',
      CI: 'paquet',
      GE: 'shekvra',
      KZ: 'paket',
      KG: 'paket',
      UA: 'upakovka',
      RS: 'paket',
      SI: 'paket',
      BG: 'opakovka',
      BA: 'paket',
      ME: 'paket',
      AD: 'paquet',
      AM: 'p-at-et-avorel',
    },
    guest: {
      KE: 'guest',
      GH: 'guest',
      ES: 'guest',
      PL: 'guest',
      PT: 'guest',
      RO: 'guest',
      MD: 'guest',
      HR: 'guest',
      IT: 'guest',
      MA: 'guest',
      CI: 'guest',
      GE: 'guest',
      KZ: 'guest',
      KG: 'guest',
      UA: 'guest',
      RS: 'gost',
      SI: 'gost',
      BG: 'gost',
      BA: 'gost',
      ME: 'gost',
      AD: 'invitat',
      AM: 'hyowr',
    },
    'guest-checkout': {
      KE: 'guest-checkout',
      GH: 'guest-checkout',
      ES: 'guest-checkout',
      PL: 'guest-checkout',
      PT: 'guest-checkout',
      RO: 'guest-checkout',
      MD: 'guest-checkout',
      HR: 'guest-checkout',
      IT: 'guest-checkout',
      MA: 'guest-checkout',
      CI: 'guest-checkout',
      GE: 'guest-checkout',
      KZ: 'guest-checkout',
      KG: 'guest-checkout',
      UA: 'guest-checkout',
      RS: 'gost-placanje',
      SI: 'gost-blagajna',
      BG: 'plashchane-na-gost',
      BA: 'zavrsetak-kupovine-gosta',
      ME: 'gost-placanje',
      AD: 'compra-invitat',
      AM: 'vcharowm-hyowri-koghmits',
    },
    checkout: {
      KE: 'checkout',
      GH: 'checkout',
      ES: 'finalizar-compra',
      PL: 'dokoncz-transakcje',
      PT: 'finalizar-compra',
      RO: 'finalizati-cumparati',
      MD: 'finalizati-cumparati',
      HR: 'finaliziraj-kupi',
      IT: 'finalizzare-acquisto',
      MA: 'terminer-achat',
      CI: 'terminer-achat',
      GE: 'qidvis-dasruleba',
      KZ: 'zavershenie-pokupki',
      KG: 'zavershenie-pokupki',
      UA: 'zavershennia-pokupki',
      RS: 'zavrsi-kupi',
      SI: 'zakljucek-nakupa',
      BG: 'zav-rshvane-na-pokupka',
      BA: 'zavrsi-kupovinu',
      ME: 'zavrsi-kupi',
      AD: 'finalitzar-compra',
      AM: 'vcharowm',
    },
    'order-thank-you': {
      KE: 'checkout/order-thank-you',
      GH: 'checkout/order-thank-you',
      ES: 'finalizar-compra/gracias',
      PL: 'zakonczenie-transakcji/podziekowanie',
      PT: 'finalizar-comprar/agradecimento',
      RO: 'finalizati-cumparati/multumesc',
      MD: 'finalizati-cumparati/multumesc',
      HR: 'finaliziraj-kupi/hvala',
      IT: 'finalizzare-acquisto/grazie',
      MA: 'terminer-achat/merci',
      CI: 'terminer-achat/merci',
      GE: 'qidvis-dasruleba/gmadlobt',
      KZ: 'zavershenie-pokupki/spasibo',
      KG: 'zavershenie-pokupki/spasibo',
      UA: 'zavershennia-pokupki/diakuiemo',
      RS: 'zavrsi-kupi/hvala-vam',
      SI: 'zakljucek-nakupa/hvala-vam',
      BG: 'zav-rshvane-na-pokupka/blagodarim-vi',
      BA: 'zavrsi-kupovinu/hvala',
      ME: 'zavrsi-kupi/hvala-vam',
      AD: 'finalitzar-compra/gracies',
      AM: 'shnorhakalowt-yown-patveri-hamar',
    },
    'order-error': {
      KE: 'checkout/order-error',
      GH: 'checkout/order-error',
      ES: 'finalizar-compra/error',
      PL: 'zakonczenie-transakcji/blad',
      PT: 'checkout/erro',
      RO: 'finalizati-cumparati/eroare',
      MD: 'finalizati-cumparati/eroare',
      HR: 'finaliziraj-kupi/pogreska',
      IT: 'checkout/errore',
      MA: 'terminer-achat/erreur',
      CI: 'terminer-achat/erreur',
      GE: 'qidvis-dasruleba/shec-doma',
      KZ: 'zavershenie-pokupki/oshibka',
      KG: 'zavershenie-pokupki/oshibka',
      UA: 'zavershennia-pokupki/pomilka',
      RS: 'zavrsi-kupi/greska',
      SI: 'zakljucek-nakupa/napaka',
      BG: 'zav-rshvane-na-pokupka/greshka',
      BA: 'zavrsi-kupovinu/greska',
      ME: 'zavrsi-kupi/greska',
      AD: 'finalitzar-compra/error',
      AM: 'patveri-skhal',
    },
    'my-account': {
      KE: 'my-account',
      GH: 'my-account',
      ES: 'mi-cuenta',
      PL: 'moje-konto',
      PT: 'minha-conta',
      RO: 'contul-meu',
      MD: 'contul-meu',
      HR: 'moj-racun',
      IT: 'il-mio-conto',
      MA: 'mon-compte',
      CI: 'mon-compte',
      GE: 'ch-emiangarishi',
      KZ: 'moi-profil',
      KG: 'moi-profil',
      UA: 'mii-profil',
      RS: 'moj-nalog',
      SI: 'moj-racun',
      BG: 'moiat-akaunt',
      BA: 'moj-racun',
      ME: 'moj-nalog',
      AD: 'el-meu-compte',
      AM: 'im-hashive',
    },
    'my-orders': {
      KE: 'my-account/my-orders',
      GH: 'my-account/my-orders',
      ES: 'mi-cuenta/pedidos',
      PL: 'moje-konto/zamowienia',
      PT: 'minha-conta/pedidos',
      RO: 'contul-meu/comenzi',
      MD: 'contul-meu/comenzi',
      HR: 'moj-racun/narudzbe',
      IT: 'il-mio-account/ordini',
      MA: 'mon-compte/commandes',
      CI: 'mon-compte/commandes',
      GE: 'ch-emiangarishi/shekvet-ebi',
      KZ: 'moi-profil-/zakazy',
      KG: 'moi-profil-/zakazy',
      UA: 'mii-profil-/zamovlennia',
      RS: 'moj-nalog/narudzbine',
      SI: 'moj-racun/narocila',
      BG: 'moiat-akaunt/por-chki',
      BA: 'moj-racun/narudzbe',
      ME: 'moj-nalog/narudzbine',
      AD: 'el-meu-compte/comandes',
      AM: 'im-patvernere',
    },
    'my-invoices': {
      KE: 'my-account/my-invoices',
      GH: 'my-account/my-invoices',
      ES: 'mi-cuenta/facturas',
      PL: 'moje-konto/my-invoices',
      PT: 'minha-conta/my-invoices',
      RO: 'contul-meu/my-invoices',
      MD: 'contul-meu/my-invoices',
      HR: 'moj-racun/my-invoices',
      IT: 'il-mio-account/my-invoices',
      MA: 'mon-compte/my-invoices',
      CI: 'mon-compte/my-invoices',
      GE: 'ch-emiangarishi/my-invoices',
      KZ: 'moi-profil-/my-invoices',
      KG: 'moi-profil-/my-invoices',
      UA: 'mii-profil-/my-invoices',
      RS: 'moj-nalog/fakture',
      SI: 'moj-racun/racuni',
      BG: 'moiat-akaunt/fakturi',
      BA: 'moj-racun/racuni',
      ME: 'moj-nalog/fakture',
      AD: 'el-meu-compte/factures',
      AM: 'im-hashiv-aprank-agrere',
    },
    'glovo-wallet': {
      KE: 'my-account/glovo-wallet',
      GH: 'my-account/glovo-wallet',
      ES: 'mi-cuenta/glovo-wallet',
      PL: 'moje-konto/glovo-wallet',
      PT: 'minha-conta/glovo-wallet',
      RO: 'contul-meu/glovo-wallet',
      MD: 'contul-meu/glovo-wallet',
      HR: 'moj-racun/glovo-wallet',
      IT: 'il-mio-account/glovo-wallet',
      MA: 'mon-compte/glovo-wallet',
      CI: 'mon-compte/glovo-wallet',
      GE: 'ch-emiangarishi/glovo-wallet',
      KZ: 'moi-profil-/glovo-wallet',
      KG: 'moi-profil-/glovo-wallet',
      UA: 'mii-profil-/glovo-wallet',
      RS: 'moj-nalog/glovo-wallet',
      SI: 'moj-racun/glovo-wallet',
      BG: 'moiat-akaunt/glovo-wallet',
      BA: 'moj-racun/glovo-wallet',
      ME: 'moj-nalog/glovo-wallet',
      AD: 'el-meu-compte/glovo-wallet',
      AM: 'im-hashive/glovo-wallet',
    },
    'glovo-bags': {
      KE: 'my-account/glovo-bags',
      GH: 'my-account/glovo-bags',
      ES: 'mi-cuenta/bolsas-glovo',
      PL: 'moje-konto/torby-glovo',
      PT: 'minha-conta/bolsas-glovo',
      RO: 'contul-meu/genti-glovo',
      MD: 'contul-meu/genti-glovo',
      HR: 'moj-racun/glovo-torbe',
      IT: 'il-mio-account/borse-glovo',
      MA: 'mon-compte/sacs-glovo',
      CI: 'mon-compte/sacs-glovo',
      GE: 'ch-emiangarishi/glovo-chantebi',
      KZ: 'moi-profil/glovo-sumkalar',
      KG: 'moi-profil/glovo-sumkalar',
      UA: 'mii-profil/glovo-sumky',
      RS: 'moj-nalog/glovo-torbe',
      SI: 'moj-racun/glovo-torbe',
      BG: 'moiat-akaunt/glovo-chanti',
      BA: 'moj-racun/glovo-torbe',
      ME: 'moj-nalog/glovo-torbe',
      AD: 'el-meu-compte/bolses-glovo',
      AM: 'im-patvernere/glovo-pajrakek',
    },
    services: {
      KE: 'services',
      GH: 'services',
      ES: 'servicios',
      PL: 'uslugi',
      PT: 'servicos',
      RO: 'servicii',
      MD: 'servicii',
      HR: 'usluge',
      IT: 'servizi',
      MA: 'services',
      CI: 'services',
      GE: 'momsaxurebebi',
      KZ: 'uslugi',
      KG: 'uslugi',
      UA: 'poslugi',
      RS: 'usluge',
      SI: 'storitve',
      BG: 'uslugi',
      BA: 'usluge',
      ME: 'usluge',
      AD: 'serveis',
      AM: 'tsarhayowt-yownner',
    },
    landings: {
      KE: 'landings',
      GH: 'landings',
      ES: 'glovo',
      PL: 'glovo',
      PT: 'glovo',
      RO: 'glovo',
      MD: 'glovo',
      HR: 'glovo',
      IT: 'glovo',
      MA: 'glovo',
      CI: 'glovo',
      GE: 'glovo',
      KZ: 'glovo',
      KG: 'glovo',
      UA: 'glovo',
      RS: 'glovo',
      SI: 'glovo',
      BG: 'glovo',
      BA: 'glovo',
      ME: 'glovo',
      AD: 'glovo',
      AM: 't-irakhayin-ejer',
    },
    promotions: {
      KE: 'promotions',
      GH: 'promotions',
      ES: 'promociones',
      PL: 'promociones',
      PT: 'promociones',
      RO: 'promociones',
      MD: 'promociones',
      HR: 'promociones',
      IT: 'promociones',
      MA: 'promociones',
      CI: 'promociones',
      GE: 'promociones',
      KZ: 'promociones',
      KG: 'promociones',
      UA: 'promociones',
      RS: 'promocije',
      SI: 'promocijske-akcije',
      BG: 'promotsii',
      BA: 'promocije',
      ME: 'promocije',
      AD: 'promocions',
      AM: 'akts-ianer',
    },
    sustainability: {
      KE: 'glovo/sustainability',
      GH: 'glovo/sustainability',
      ES: 'glovo/sostenibilidad',
      PL: 'glovo/sustainability',
      PT: 'glovo/sustainability',
      RO: 'glovo/sustainability',
      MD: 'glovo/sustainability',
      HR: 'glovo/sustainability',
      IT: 'glovo/sustainability',
      MA: 'glovo/sustainability',
      CI: 'glovo/sustainability',
      GE: 'glovo/sustainability',
      KZ: 'glovo/sustainability',
      KG: 'glovo/sustainability',
      UA: 'glovo/sustainability',
      RS: 'glovo/odrzivost',
      SI: 'glovo/trajnost',
      BG: 'por-chka/ustoichivost',
      BA: 'glovo/odrzivost',
      ME: 'glovo/odrzivost',
      AD: 'glovo/sostenibilitat',
      AM: 'kayownowt-yown',
    },
    faqs: {
      KE: 'faqs',
      GH: 'faqs',
      ES: 'preguntas-frecuentes',
      PL: 'czeste-pytania',
      PT: 'perguntas-frequentes',
      RO: 'intrebari-frecvente',
      MD: 'intrebari-frecvente',
      HR: 'cesta-pitanja',
      IT: 'domande-frequenti',
      MA: 'questions-frequentes',
      CI: 'questions-frequentes',
      GE: 'xshiraddasmulikit-xvebi',
      KZ: 'chasto-zadavaemye-voprosy',
      KG: 'chasto-zadavaemye-voprosy',
      UA: 'chasti-zapitannia',
      RS: 'cesta-pitanja',
      SI: 'pogosta-vprasanja',
      BG: 'chesto-zadavani-v-prosi',
      BA: 'cesto-postavljena-pitanja',
      ME: 'cesta-pitanja',
      AD: 'preguntes-frequents',
      AM: 'hth',
    },
    invoices: {
      KE: 'invoices',
      GH: 'invoices',
      ES: 'facturas',
      PL: 'faktury',
      PT: 'faturas',
      RO: 'facturi',
      MD: 'facturi',
      HR: 'racuni',
      IT: 'fatture',
      MA: 'factures',
      CI: 'factures',
      GE: 'invoisebi',
      KZ: 'scheta',
      KG: 'scheta',
      UA: 'invoisi',
      RS: 'fakture',
      SI: 'racuni',
      BG: 'fakturi',
      BA: 'racuni',
      ME: 'fakture',
      AD: 'factures',
      AM: 'hashiv-aprank-agrer',
    },
    orders: {
      KE: 'orders',
      GH: 'orders',
      ES: 'pedidos',
      PL: 'zamowienia',
      PT: 'pedidos',
      RO: 'comenzi',
      MD: 'comenzi',
      HR: 'narudzbe',
      IT: 'ordini',
      MA: 'commandes',
      CI: 'commandes',
      GE: 'shekvet-ebi',
      KZ: 'zakazy',
      KG: 'zakazy',
      UA: 'zamovlennia',
      RS: 'narudzbine',
      SI: 'narocila',
      BG: 'por-chki',
      BA: 'narudzbe',
      ME: 'narudzbine',
      AD: 'comandes',
      AM: 'patverner',
    },
    'ongoing-order': {
      KE: 'ongoing-order',
      GH: 'ongoing-order',
      ES: 'pedido-en-curso',
      PL: 'biezace-zamowienie',
      PT: 'pedido-em-progresso',
      RO: 'comanda-in-curs',
      MD: 'comanda-in-curs',
      HR: 'narudzba-u-tijeku',
      IT: 'ordine-in-corso',
      MA: 'commande-en-cours',
      CI: 'commande-en-cours',
      GE: 'mimdinare-shekvet-a',
      KZ: 'tekushchii-zakaz',
      KG: 'tekushchii-zakaz',
      UA: 'potochne-zamovlennia',
      RS: 'narudzbina-u-toku',
      SI: 'narocilo-v-teku',
      BG: 'tekushcha-por-chka',
      BA: 'tekuca-narudzba',
      ME: 'narudzbina-u-toku',
      AD: 'comanda-en-curs',
      AM: 'ent-ats-ik-patver',
    },
    'past-order': {
      KE: 'past-order',
      GH: 'past-order',
      ES: 'pedido-pasado',
      PL: 'przeszle-zamowienie',
      PT: 'pedido-passado',
      RO: 'comanda-anterioara',
      MD: 'comanda-anterioara',
      HR: 'prosla-narudzba',
      IT: 'ordine-passato',
      MA: 'anciennes-commandes',
      CI: 'anciennes-commandes',
      GE: 'cina-shekvet-a',
      KZ: 'proshlyi-zakaz',
      KG: 'proshlyi-zakaz',
      UA: 'minule-zamovlennia',
      RS: 'prosla-narudzbina',
      SI: 'preteklo-narocilo',
      BG: 'minala-por-chka',
      BA: 'proska-narudzba',
      ME: 'prosla-narudzbina',
      AD: 'comanda-anterior',
      AM: 'nakhord-patver',
    },
    payments: {
      KE: 'payments',
      GH: 'payments',
      ES: 'pagos',
      PL: 'platnosci',
      PT: 'pagamentos',
      RO: 'plati',
      MD: 'plati',
      HR: 'uplate',
      IT: 'pagamenti',
      MA: 'paiements',
      CI: 'paiements',
      GE: 'gadaxdebi',
      KZ: 'platezhi',
      KG: 'platezhi',
      UA: 'platezhi',
      RS: 'placanja',
      SI: 'placila',
      BG: 'plashchaniia',
      BA: 'uplate',
      ME: 'placanja',
      AD: 'pagaments',
      AM: 'vcharowmner',
    },
    'general-questions': {
      KE: 'general-questions',
      GH: 'general-questions',
      ES: 'preguntas-generales',
      PL: 'pytania-ogolne',
      PT: 'perguntas-gerais',
      RO: 'intrebari-generale',
      MD: 'intrebari-generale',
      HR: 'opca-pitanja',
      IT: 'domande-generali',
      MA: 'questions-generales',
      CI: 'questions-generales',
      GE: 'zogadi-kit-xvebi',
      KZ: 'obshchie-voprosy',
      KG: 'obshchie-voprosy',
      UA: 'zagal-ni-pitannia',
      RS: 'opsta-pitanja',
      SI: 'splosna-vprasanja',
      BG: 'obshchi-v-prosi',
      BA: 'opca-pitanja',
      ME: 'opsta-pitanja',
      AD: 'preguntes-generals',
      AM: 'endhanowr-harts-er',
    },
    error: {
      KE: 'error',
      GH: 'error',
      ES: 'error',
      PL: 'blad',
      PT: 'erro',
      RO: 'eroare',
      MD: 'eroare',
      HR: 'pogreska',
      IT: 'errore',
      MA: 'erreur',
      CI: 'erreur',
      GE: 'shec-doma',
      KZ: 'oshibka',
      KG: 'oshibka',
      UA: 'pomilka',
      RS: 'greska',
      SI: 'napaka',
      BG: 'greshka',
      BA: 'greska',
      ME: 'greska',
      AD: 'error',
      AM: 'skhal',
    },
    'cookies-policy': {
      KE: 'cookies-policy',
      GH: 'cookies-policy',
      ES: 'politica-de-cookies',
      PL: 'polityka-plikow-cookie',
      PT: 'politica-de-cookies',
      RO: 'politica-privind-cookie-urile',
      MD: 'politica-privind-cookie-urile',
      HR: 'pravila-kolacica',
      IT: 'politica-sui-cookie',
      MA: 'politique-de-cookies',
      CI: 'politique-de-cookies',
      GE: 'k-uk-i-p-ailebis-politika',
      KZ: 'politika-ispol-zovaniia-failov-cookie',
      KG: 'politika-ispol-zovaniia-failov-cookie',
      UA: 'politika-vikoristannia-failiv-cookie',
      RS: 'politika-za-kolacice',
      SI: 'pravilnik-o-piskotkih',
      BG: 'politika-za-biskvitkite',
      BA: 'politika-o-kolacicima',
      ME: 'politika-za-kolacice',
      AD: 'politica-de-cookies',
      AM: 'k-owk-ineri-k-aghak-akanowt-yown',
    },
    brands: {
      KE: 'brands',
      GH: 'brands',
      ES: 'marcas',
      PL: 'marki',
      PT: 'marcas',
      RO: 'branduri',
      MD: 'branduri',
      HR: 'brendovi',
      IT: 'marchi',
      MA: 'marques',
      CI: 'marques',
      GE: 'brendebi',
      KZ: 'brendy',
      KG: 'brendy',
      UA: 'brendy',
      RS: 'brendovi',
      SI: 'znamke',
      BG: 'marki',
      BA: 'brendovi',
      ME: 'brendovi',
      AD: 'marques',
      AM: 'brender',
    },
    tracking: {
      KE: 'tracking',
      GH: 'tracking',
      ES: 'tracking',
      PL: 'tracking',
      PT: 'tracking',
      RO: 'tracking',
      MD: 'tracking',
      HR: 'tracking',
      IT: 'tracking',
      MA: 'tracking',
      CI: 'tracking',
      GE: 'tracking',
      KZ: 'tracking',
      KG: 'tracking',
      UA: 'tracking',
      RS: 'tracking',
      SI: 'tracking',
      BG: 'tracking',
      BA: 'tracking',
      ME: 'tracking',
      AD: 'tracking',
      AM: 'tracking',
    },
    'not-available': {
      KE: 'not-available',
      GH: 'not-available',
      ES: 'not-available',
      PL: 'not-available',
      PT: 'not-available',
      RO: 'not-available',
      MD: 'not-available',
      HR: 'not-available',
      IT: 'not-available',
      MA: 'not-available',
      CI: 'not-available',
      GE: 'not-available',
      KZ: 'not-available',
      KG: 'not-available',
      UA: 'not-available',
      RS: 'not-available',
      SI: 'not-available',
      BG: 'not-available',
      BA: 'not-available',
      ME: 'not-available',
      AD: 'not-available',
      AM: 'not-available',
    },
    cancel: {
      KE: 'cancel', // sin traducción
      GH: 'cancel', // sin traducción
      ES: 'cancelar',
      PL: 'cancel', // sin traducción
      PT: 'cancelar',
      RO: 'cancel', // sin traducción
      MD: 'cancel', // sin traducción
      HR: 'cancel', // sin traducción
      IT: 'cancel', // sin traducción
      MA: 'cancel', // sin traducción
      CI: 'cancel', // sin traducción
      GE: 'cancel', // sin traducción
      KZ: 'cancel', // sin traducción
      KG: 'cancel', // sin traducción
      UA: 'cancel', // sin traducción
      RS: 'cancel', // sin traducción
      SI: 'cancel', // sin traducción
      BG: 'cancel', // sin traducción
      BA: 'cancel', // sin traducción
      ME: 'cancel', // sin traducción
      AD: 'cancel', // sin traducción
      AM: 'cancel', // sin traducción
    },
    contact: {
      KE: 'contact', // sin traducción
      GH: 'contact', // sin traducción
      ES: 'contact', // sin traducción
      PL: 'contact', // sin traducción
      PT: 'contact', // sin traducción
      RO: 'contact', // sin traducción
      MD: 'contact', // sin traducción
      HR: 'contact', // sin traducción
      IT: 'contact', // sin traducción
      MA: 'contact', // sin traducción
      CI: 'contact', // sin traducción
      GE: 'contact', // sin traducción
      KZ: 'contact', // sin traducción
      KG: 'contact', // sin traducción
      UA: 'contact', // sin traducción
      RS: 'contact', // sin traducción
      SI: 'contact', // sin traducción
      BG: 'contact', // sin traducción
      BA: 'contact', // sin traducción
      ME: 'contact', // sin traducción
      AD: 'contact', // sin traducción
      AM: 'contact', // sin traducción
    },
    compensation: {
      KE: 'compensation', // sin traducción
      GH: 'compensation', // sin traducción
      ES: 'compensacion',
      PL: 'compensation', // sin traducción
      PT: 'compensacao',
      RO: 'compensation', // sin traducción
      MD: 'compensation', // sin traducción
      HR: 'compensation', // sin traducción
      IT: 'compensation', // sin traducción
      MA: 'compensation', // sin traducción
      CI: 'compensation', // sin traducción
      GE: 'compensation', // sin traducción
      KZ: 'compensation', // sin traducción
      KG: 'compensation', // sin traducción
      UA: 'compensation', // sin traducción
      RS: 'compensation', // sin traducción
      SI: 'compensation', // sin traducción
      BG: 'compensation', // sin traducción
      BA: 'compensation', // sin traducción
      ME: 'compensation', // sin traducción
      AD: 'compensation', // sin traducción
      AM: 'compensation', // sin traducción
    },
    'voucher-success': {
      KE: 'voucher-success', // sin traducción
      GH: 'voucher-success', // sin traducción
      ES: 'voucher-creado',
      PL: 'voucher-success', // sin traducción
      PT: 'voucher-sucesso',
      RO: 'voucher-success', // sin traducción
      MD: 'voucher-success', // sin traducción
      HR: 'voucher-success', // sin traducción
      IT: 'voucher-success', // sin traducción
      MA: 'voucher-success', // sin traducción
      CI: 'voucher-success', // sin traducción
      GE: 'voucher-success', // sin traducción
      KZ: 'voucher-success', // sin traducción
      KG: 'voucher-success', // sin traducción
      UA: 'voucher-success', // sin traducción
      RS: 'voucher-success', // sin traducción
      SI: 'voucher-success', // sin traducción
      BG: 'voucher-success', // sin traducción
      BA: 'voucher-success', // sin traducción
      ME: 'voucher-success', // sin traducción
      AD: 'voucher-success', // sin traducción
      AM: 'voucher-success', // sin traducción
    },
    refunds: {
      KE: 'refunds', // sin traducción
      GH: 'refunds', // sin traducción
      ES: 'reembolsos',
      PL: 'refunds', // sin traducción
      PT: 'restituicoes',
      RO: 'refunds', // sin traducción
      MD: 'refunds', // sin traducción
      HR: 'refunds', // sin traducción
      IT: 'refunds', // sin traducción
      MA: 'refunds', // sin traducción
      CI: 'refunds', // sin traducción
      GE: 'refunds', // sin traducción
      KZ: 'refunds', // sin traducción
      KG: 'refunds', // sin traducción
      UA: 'refunds', // sin traducción
      RS: 'refunds', // sin traducción
      SI: 'refunds', // sin traducción
      BG: 'refunds', // sin traducción
      BA: 'refunds', // sin traducción
      ME: 'refunds', // sin traducción
      AD: 'refunds', // sin traducción
      AM: 'refunds', // sin traducción
    },
    returns: {
      KE: 'returns', // sin traducción
      GH: 'returns', // sin traducción
      ES: 'devoluciones',
      PL: 'returns', // sin traducción
      PT: 'retorna',
      RO: 'returns', // sin traducción
      MD: 'returns', // sin traducción
      HR: 'returns', // sin traducción
      IT: 'returns', // sin traducción
      MA: 'returns', // sin traducción
      CI: 'returns', // sin traducción
      GE: 'returns', // sin traducción
      KZ: 'returns', // sin traducción
      KG: 'returns', // sin traducción
      UA: 'returns', // sin traducción
      RS: 'returns', // sin traducción
      SI: 'returns', // sin traducción
      BG: 'returns', // sin traducción
      BA: 'returns', // sin traducción
      ME: 'returns', // sin traducción
      AD: 'returns', // sin traducción
      AM: 'returns', // sin traducción
    },
    return: {
      KE: 'return', // sin traducción
      GH: 'return', // sin traducción
      ES: 'devolucion',
      PL: 'return', // sin traducción
      PT: 'devolucao',
      RO: 'return', // sin traducción
      MD: 'return', // sin traducción
      HR: 'return', // sin traducción
      IT: 'return', // sin traducción
      MA: 'return', // sin traducción
      CI: 'return', // sin traducción
      GE: 'return', // sin traducción
      KZ: 'return', // sin traducción
      KG: 'return', // sin traducción
      UA: 'return', // sin traducción
      RS: 'return', // sin traducción
      SI: 'return', // sin traducción
      BG: 'return', // sin traducción
      BA: 'return', // sin traducción
      ME: 'return', // sin traducción
      AD: 'return', // sin traducción
      AM: 'return', // sin traducción
    },
    reason: {
      KE: 'reason', // sin traducción
      GH: 'reason', // sin traducción
      ES: 'motivo',
      PL: 'reason', // sin traducción
      PT: 'razao',
      RO: 'reason', // sin traducción
      MD: 'reason', // sin traducción
      HR: 'reason', // sin traducción
      IT: 'reason', // sin traducción
      MA: 'reason', // sin traducción
      CI: 'reason', // sin traducción
      GE: 'reason', // sin traducción
      KZ: 'reason', // sin traducción
      KG: 'reason', // sin traducción
      UA: 'reason', // sin traducción
      RS: 'reason', // sin traducción
      SI: 'reason', // sin traducción
      BG: 'reason', // sin traducción
      BA: 'reason', // sin traducción
      ME: 'reason', // sin traducción
      AD: 'reason', // sin traducción
      AM: 'reason', // sin traducción
    },
    'waiting-for-compensation': {
      KE: 'waiting-for-compensation', // sin traducción
      GH: 'waiting-for-compensation', // sin traducción
      ES: 'pendiente-decompensación',
      PL: 'waiting-for-compensation', // sin traducción
      PT: 'aguardando-compensacao',
      RO: 'waiting-for-compensation', // sin traducción
      MD: 'waiting-for-compensation', // sin traducción
      HR: 'waiting-for-compensation', // sin traducción
      IT: 'waiting-for-compensation', // sin traducción
      MA: 'waiting-for-compensation', // sin traducción
      CI: 'waiting-for-compensation', // sin traducción
      GE: 'waiting-for-compensation', // sin traducción
      KZ: 'waiting-for-compensation', // sin traducción
      KG: 'waiting-for-compensation', // sin traducción
      UA: 'waiting-for-compensation', // sin traducción
      RS: 'waiting-for-compensation', // sin traducción
      SI: 'waiting-for-compensation', // sin traducción
      BG: 'waiting-for-compensation', // sin traducción
      BA: 'waiting-for-compensation', // sin traducción
      ME: 'waiting-for-compensation', // sin traducción
      AD: 'waiting-for-compensation', // sin traducción
      AM: 'waiting-for-compensation', // sin traducción
    },
    'approved': {
      KE: 'approved', // sin traducción
      GH: 'approved', // sin traducción
      ES: 'aprobado',
      PL: 'approved', // sin traducción
      PT: 'aprovado',
      RO: 'approved', // sin traducción
      MD: 'approved', // sin traducción
      HR: 'approved', // sin traducción
      IT: 'approved', // sin traducción
      MA: 'approved', // sin traducción
      CI: 'approved', // sin traducción
      GE: 'approved', // sin traducción
      KZ: 'approved', // sin traducción
      KG: 'approved', // sin traducción
      UA: 'approved', // sin traducción
      RS: 'approved', // sin traducción
      SI: 'approved', // sin traducción
      BG: 'approved', // sin traducción
      BA: 'approved', // sin traducción
      ME: 'approved', // sin traducción
      AD: 'approved', // sin traducción
      AM: 'approved', // sin traducción
    },
    'landing-courier': {
      KE: 'landing-courier',
      GH: 'landing-courier',
      ES: 'landing-courier',
      PL: 'landing-courier',
      PT: 'landing-courier',
      RO: 'landing-courier',
      MD: 'landing-courier',
      HR: 'landing-courier',
      IT: 'landing-courier',
      MA: 'landing-courier',
      CI: 'landing-courier',
      GE: 'landing-courier',
      KZ: 'landing-courier',
      KG: 'landing-courier',
      UA: 'landing-courier',
      RS: 'landing-courier',
      SI: 'landing-courier',
      BG: 'landing-courier',
      BA: 'landing-courier',
      ME: 'landing-courier',
      AD: 'landing-courier',
      AM: 'landing-courier',
    },
    'landing-custom-products': {
      KE: 'landing-custom-products',
      GH: 'landing-custom-products',
      ES: 'landing-custom-products',
      PL: 'landing-custom-products',
      PT: 'landing-custom-products',
      RO: 'landing-custom-products',
      MD: 'landing-custom-products',
      HR: 'landing-custom-products',
      IT: 'landing-custom-products',
      MA: 'landing-custom-products',
      CI: 'landing-custom-products',
      GE: 'landing-custom-products',
      KZ: 'landing-custom-products',
      KG: 'landing-custom-products',
      UA: 'landing-custom-products',
      RS: 'landing-custom-products',
      SI: 'landing-custom-products',
      BG: 'landing-custom-products',
      BA: 'landing-custom-products',
      ME: 'landing-custom-products',
      AD: 'landing-custom-products',
      AM: 'landing-custom-products',
    },
    'buy-again': {
      KE: 'buy-again',
      GH: 'buy-again',
      ES: 'compra-de-nuevo',
      PL: 'kup-ponownie',
      PT: 'comprar-novamente',
      RO: 'cumpără-din-nou',
      MD: 'cumpără-din-nou',
      HR: 'kupi-ponovno',
      IT: 'compra-di-nuovo',
      MA: 'acheter-encore',
      CI: 'acheter-encore',
      GE: 'ხელახლა-ყიდვა',
      KZ: 'қайта-алу',
      KG: 'кайра-сатып-алуу',
      UA: 'купити-знову',
      RS: 'kupi-opet',
      SI: 'kupiti-ponovno',
      BG: 'купете-отново',
      BA: 'kupi-ponovo',
      ME: 'kupi-ponovo',
      AD: 'compra-de-nuevo',
      AM: 'կրկին-գնել',
    },
    'terms-and-conditions': {
      KE: 'terms-and-conditions',
      GH: 'terms-and-conditions',
      ES: 'terminos-y-condiciones',
      PL: 'warunki-korzystania',
      PT: 'termos-e-condições',
      RO: 'termeni-și-condiții',
      MD: 'termeni-și-condiții',
      HR: 'uvjeti-korištenja',
      IT: 'termini-e-condizioni',
      MA: 'termes-et-conditions',
      CI: 'termes-et-conditions',
      GE: 'წესები-და-პირობები',
      KZ: 'пайдалану-шарттары',
      KG: 'колдонуу-шарттары',
      UA: 'умови-користування',
      RS: 'uslovi-korišćenja',
      SI: 'pogoji-uporabe',
      BG: 'условия-за-ползване',
      BA: 'uslovi-korišćenja',
      ME: 'uslovi-korišćenja',
      AD: 'terminos-y-condiciones',
      AM: 'պայմաններ-և-պայմանականություններ',
    },
    'return-policy': {
      KE: 'return-policy',
      GH: 'return-policy',
      ES: 'politica-de-devoluciones',
      PL: 'polityka-zwrotow',
      PT: 'politica-de-devoluções',
      RO: 'politica-de-retur',
      MD: 'politica-de-retur',
      HR: 'politika-povrata',
      IT: 'politica-di-reso',
      MA: 'politique-de-retour',
      CI: 'politique-de-retour',
      GE: 'დაბრუნების-პოლიტიკა',
      KZ: 'қайтару-саясаты',
      KG: 'кайтаруу-саясаты',
      UA: 'політика-повернення',
      RS: 'politika-povrata',
      SI: 'politika-vračil',
      BG: 'политика-за-връщане',
      BA: 'politika-povrata',
      ME: 'politika-povrata',
      AD: 'politica-de-devoluciones',
      AM: 'վերադարձի-քաղաքականություն',
    },
    posts: {
      KE: 'posts',
      GH: 'posts',
      ES: 'noticias',
      PL: 'posty',
      PT: 'postagens',
      RO: 'postări',
      MD: 'postări',
      HR: 'objave',
      IT: 'post',
      MA: 'posts',
      CI: 'posts',
      GE: 'პოსტები',
      KZ: 'посттар',
      KG: 'посттор',
      UA: 'пости',
      RS: 'objave',
      SI: 'objave',
      BG: 'постове',
      BA: 'objave',
      ME: 'objave',
      AD: 'noticias',
      AM: 'գրառումներ',
    },
    'privacy-policy': {
      KE: 'privacy-policy',
      GH: 'privacy-policy',
      ES: 'politica-de-privacidad',
      PL: 'polityka-prywatności',
      PT: 'politica-de-privacidade',
      RO: 'politica-de-confidențialitate',
      MD: 'politica-de-confidențialitate',
      HR: 'politika-privatnosti',
      IT: 'politica-sulla-privacy',
      MA: 'politique-de-confidentialite',
      CI: 'politique-de-confidentialite',
      GE: 'კონფიდენციალურობის-პოლიტიკა',
      KZ: 'құпиялылық-саясаты',
      KG: 'купуялуулук-саясаты',
      UA: 'політика-конфіденційності',
      RS: 'politika-privatnosti',
      SI: 'politika-zasebnosti',
      BG: 'политика-за-поверителност',
      BA: 'politika-privatnosti',
      ME: 'politika-privatnosti',
      AD: 'politica-de-privacidad',
      AM: 'գաղտնիության-քաղաքականություն',
    },
    support: {
      KE: 'support',
      GH: 'support',
      ES: 'soporte',
      PL: 'wsparcie',
      PT: 'suporte',
      RO: 'suport',
      MD: 'suport',
      HR: 'podrska',
      IT: 'supporto',
      MA: 'support',
      CI: 'support',
      GE: 'მხარდაჭერა',
      KZ: 'қолдау',
      KG: 'колдоо',
      UA: 'підтримка',
      RS: 'podrska',
      SI: 'podpora',
      BG: 'поддръжка',
      BA: 'podrska',
      ME: 'podrska',
      AD: 'soporte',
      AM: 'աջակցություն',
    },
    'contact-support': {
      KE: 'contact-support',
      GH: 'contact-support',
      ES: 'contactar-con-soporte',
      PL: 'kontakt-ze-wsparciem',
      PT: 'contactar-suporte',
      RO: 'contacta-suportul',
      MD: 'contacta-suportul',
      HR: 'kontakt-podrska',
      IT: 'contattare-supporto',
      MA: 'contact-support',
      CI: 'contact-support',
      GE: 'დაუკავშირდით-მხარდაჭერას',
      KZ: 'қолдаумен-байланысу',
      KG: 'колдоо-мн-байланышуу',
      UA: 'зв’язок-із-підтримкою',
      RS: 'kontakt-podrska',
      SI: 'kontakt-podpora',
      BG: 'връзка-с-поддръжката',
      BA: 'kontakt-podrska',
      ME: 'kontakt-podrska',
      AD: 'contactar-con-soporte',
      AM: 'հետադարձ-կապ-աջակցություն',
    },
  },
  validations: {
    spaces: /^(?!\s+$).+/,
    invalidCharacters: /[\u10A0-\u10FF]+/,
    password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\W]).{10,}$/
  },
  landingIndex: {
    'plan-de-publicidad-de-google-ads': '1',
    'plan-de-publicidad-de-social-ads': '2',
  },
};
